import NewSlideshow from '../../classes/NewSlideshow';

export const initComplexesList = () => {
	const spots = document.querySelectorAll( 'section.complexes-list li.spot-card div.new-slider[data-count]' );

	if ( !spots.length )
	{
		return;
	}

	Array.from( spots ).forEach( ( it ) => {
		const sliderInstance = new NewSlideshow( { 
			element: it,
			autoWidth: true
		} );
	
		sliderInstance.init();
	} );
};